<template>
  <button type="button" class="icon_button">
    <slot class="icon_button__icon"></slot>
    <span class="icon_button__label">{{ label }}</span>
  </button>
</template>

<script>
import BaseComponent from "../BaseComponent";
import InteractiveElement from "../mixins/InteractiveElements";

/**
 * @group Buttons
 * This is a small label with an icon next to it. Useful for controls.
 * For example: the clear button in the Rating Input uses this.
 */
export default {
  mixins: [BaseComponent, InteractiveElement],
  name: "IconButton",
  props: {
    label: {
      required: true,
      type: String,
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../style_variables/style_variables.scss";
.icon_button {
  @extend %button_typography_style;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0);
  border: 0px;
  padding-right: 0px;
  margin-right: 0px;
  color: $grey_french;

  &:hover {
    cursor: pointer;
    color: $grey_mineshaft;
  }
  .icon_button__label {
    display: inline-block;
    margin: 0px 0px 0px 4px;
  }
}
</style>
